"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { documentLanguageFromPublicLocation } from "@/lib/i18n";

export default function DocumentLanguage() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const locale = searchParams.get("locale");

  useEffect(() => {
    const language = documentLanguageFromPublicLocation(pathname, window.location.hostname, locale);
    if (document.documentElement.lang !== language) {
      document.documentElement.lang = language;
    }
  }, [locale, pathname]);

  return null;
}
